var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "_plin",
      class: ((_obj = {}),
      (_obj["_p" + _vm.position] = _vm.position),
      (_obj["_a" + _vm.align] = _vm.align != "start"),
      (_obj._busy = _vm.busy),
      (_obj._slow = _vm.duration >= 1000),
      _obj),
      style: { width: _vm.width, height: _vm.height },
      attrs: { inert: _vm.blocking && _vm.busy }
    },
    [
      _c("transition", { attrs: { name: "_plint", duration: 1000 } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.show && _vm.ready,
                expression: "show && ready"
              }
            ],
            staticClass: "_plinbar",
            attrs: {
              role: "progressbar",
              "aria-valuenow": _vm.value,
              "aria-valuemin": _vm.value !== undefined ? _vm.min : undefined,
              "aria-valuemax": _vm.value !== undefined ? _vm.max : undefined
            }
          },
          [
            _c("div", { staticClass: "_plinbg" }),
            _c("div", {
              staticClass: "_plinfg",
              class: { _inf: _vm.value === undefined },
              style: {
                width: _vm.percent,
                "transition-duration": _vm.duration + "ms"
              },
              on: { transitionend: _vm._done }
            })
          ]
        )
      ]),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }